const BYTES_PER_MB = 1024 * 1024;

export function formatFileSizeInMB(bytes?: number): string {
    if (!bytes) return '0 MB';
    return `${(bytes / BYTES_PER_MB).toFixed(2)} MB`;
}
